'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TabPane;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  cssModule: _react.PropTypes.object,
  tabId: _react.PropTypes.any
};
var contextTypes = {
  activeTabId: _react.PropTypes.any
};

function TabPane(props, context) {
  var className = props.className;
  var cssModule = props.cssModule;
  var tabId = props.tabId;
  var children = props.children;

  var attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'children']);

  var classes = (0, _utils.mapToCssModules)((0, _classnames2.default)('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return _react2.default.createElement(
    'div',
    _extends({}, attributes, { className: classes }),
    children
  );
}
TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/TabPane.js
 ** module id = 1196
 ** module chunks = 0
 **/